import { useMemo } from 'react';
import { useRouter } from '@cp/shared/router';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { coreLocationApi } from '@cp/entities/location';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useAuthService, useRegistrationApiProvider, useRegistrationStorage } from '../api';
import { RegistrationService } from './registrationService';

export const useRegistrationService = (): RegistrationService => {
  const router = useRouter();
  const resolver = useClientWebResolver();
  const api = useRegistrationApiProvider();
  const registrationStorage = useRegistrationStorage();
  const authService = useAuthService();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  return useMemo(
    () =>
      new RegistrationService(api, router, resolver, registrationStorage, authService, (cityId: number) => {
        return dispatch(coreLocationApi.endpoints.getCityById.initiate({ id: cityId })).unwrap();
      }),
    [api, router, resolver, registrationStorage, authService, dispatch],
  );
};
